import * as THREE from 'three';
import {buildCircleFromThreePoints2D} from './buildCircleFromThreePoints2D';
import {normalizeAngle} from './normalizeAngle';
import {isAngleBetweenCCW} from './isAngleBetweenCCW';
import {normalizeArcAngles} from './normalizeArcAngles';

/**
 * 根据三个 2D 点构建圆弧的完整几何数据（圆心、半径、起止角、方向等）。
 * @param start 起点。
 * @param end 终点。
 * @param through 弧上经过的点。
 * @returns 圆弧几何数据；三点共线或无法构建时返回 null。
 */
export function buildArcFromThreePoints2D(
    start: THREE.Vector2,
    end: THREE.Vector2,
    through: THREE.Vector2,
): {
    center: THREE.Vector2;
    radius: number;
    startAngle: number;
    endAngle: number;
    angleRange: number;
    clockwise: boolean;
    angle: number;
} | null {
    const circleData = buildCircleFromThreePoints2D(start, end, through);
    if (!circleData) {
        return null;
    }
    const { center, radius } = circleData;
    const startAngleRaw = Math.atan2(start.y - center.y, start.x - center.x);
    const endAngleRaw = Math.atan2(end.y - center.y, end.x - center.x);
    const throughAngleRaw = Math.atan2(through.y - center.y, through.x - center.x);
    const startAngle = normalizeAngle(startAngleRaw);
    const endAngle = normalizeAngle(endAngleRaw);
    const throughAngle = normalizeAngle(throughAngleRaw);
    const ccw = isAngleBetweenCCW(startAngle, endAngle, throughAngle);
    const clockwise = !ccw;
    const normalized = normalizeArcAngles(startAngle, endAngle, clockwise);
    return {
        center,
        radius,
        startAngle: normalized.start,
        endAngle: normalized.end,
        angleRange: normalized.angleRange,
        clockwise,
        angle: normalized.angleRange * 180 / Math.PI,
    };
}
